var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6573282040dd5fe5d5f75595b53642ee6a225003"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["book-front@booklinik"]={id:"6573282040dd5fe5d5f75595b53642ee6a225003"};
      